(function(){
  function toast(msg){
    var t=document.createElement('div');t.className='sp-copied';t.setAttribute('role','status');t.textContent=msg;
    document.body.appendChild(t);setTimeout(function(){t.remove()},1800);
  }
  function copy(text){
    if(navigator.clipboard&&window.isSecureContext){return navigator.clipboard.writeText(text)}
    var ta=document.createElement('textarea');ta.value=text;ta.style.position='fixed';ta.style.opacity='0';document.body.appendChild(ta);ta.select();
    try{document.execCommand('copy')}catch(e){}ta.remove();return Promise.resolve();
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-copy],[data-copy-from]');
    if(!b)return;
    var text=b.getAttribute('data-copy');
    if(text===null){var src=document.getElementById(b.getAttribute('data-copy-from'));text=src?src.innerText.trim():''}
    copy(text).then(function(){toast(b.getAttribute('data-copy-msg')||'Copié')});
  });

  /* Onglets */
  document.querySelectorAll('[data-sp-tabs]').forEach(function(box){
    var tabs=box.querySelectorAll('[role=tab]');
    tabs.forEach(function(tab){
      tab.addEventListener('click',function(){
        tabs.forEach(function(t){
          var on=t===tab;t.setAttribute('aria-selected',on?'true':'false');
          var p=document.getElementById(t.getAttribute('aria-controls'));if(p)p.hidden=!on;
        });
      });
    });
  });

  /* Filtres produits (espace ambassadrice) */
  var grid=document.querySelector('[data-sp-products]');
  if(grid){
    var cards=grid.querySelectorAll('[data-tags]');
    var q=document.querySelector('[data-sp-search]');
    var cur='all';
    var run=function(){
      var term=(q&&q.value||'').toLowerCase().trim();
      var n=0;
      cards.forEach(function(c){
        var okF=cur==='all'||(' '+c.getAttribute('data-tags')+' ').indexOf(' '+cur+' ')>-1;
        var okQ=!term||c.getAttribute('data-name').indexOf(term)>-1;
        c.hidden=!(okF&&okQ);if(!c.hidden)n++;
      });
      var e=document.querySelector('[data-sp-empty]');if(e)e.hidden=n>0;
    };
    document.querySelectorAll('[data-filter]').forEach(function(p){
      p.addEventListener('click',function(){
        cur=p.getAttribute('data-filter');
        document.querySelectorAll('[data-filter]').forEach(function(x){x.classList.toggle('is-on',x===p);x.setAttribute('aria-pressed',x===p?'true':'false')});
        run();
      });
    });
    if(q){
      var params=new URLSearchParams(location.search);if(params.get('q'))q.value=params.get('q');
      q.addEventListener('input',run);
      q.form&&q.form.addEventListener('submit',function(ev){ev.preventDefault();run()});
    }
    run();
  }

  /* Progression de l'Académie (mémorisée sur cet appareil) */
  var acad=document.querySelector('[data-sp-acad]');
  if(acad){
    var key='sp-acad-'+acad.getAttribute('data-sp-acad');
    var done={};
    try{done=JSON.parse(localStorage.getItem(key)||'{}')||{}}catch(e){done={}}
    var lessons=acad.querySelectorAll('[data-lesson]');
    var paint=function(){
      var n=0;
      lessons.forEach(function(l){
        var on=!!done[l.getAttribute('data-lesson')];
        l.classList.toggle('is-done',on);if(on)n++;
        var b=l.querySelector('[data-done]');if(b)b.textContent=on?'Leçon terminée ✓':'Marquer comme terminée';
      });
      var pct=lessons.length?Math.round(n/lessons.length*100):0;
      document.querySelectorAll('[data-sp-pct]').forEach(function(el){el.textContent=pct+' %'});
      document.querySelectorAll('[data-sp-count]').forEach(function(el){el.textContent=n+' / '+lessons.length});
      document.querySelectorAll('[data-sp-bar]').forEach(function(el){el.style.width=pct+'%'});
    };
    acad.addEventListener('click',function(e){
      var b=e.target.closest('[data-done]');if(!b)return;
      var id=b.closest('[data-lesson]').getAttribute('data-lesson');
      done[id]=!done[id];
      try{localStorage.setItem(key,JSON.stringify(done))}catch(err){}
      paint();
    });
    paint();
  }
})();